import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import moment from 'moment';
import api from '../api/api';
// import router from '../router/index';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    configLeftNav: {
      content: [],
      seo: [],
    },
    navName: localStorage.getItem('navName') || '',
    publicUrl: localStorage.getItem('publicUrl') || '',
    is_page: '',
    have_page: '',
    editContent: '',
    loading: true,
    websiteId: localStorage.getItem('webSite') || '',
    webSiteChildIds: localStorage.getItem('webSiteChildIds') || '',
    articleId: localStorage.getItem('articleId') || '',
    linkId: localStorage.getItem('linkId') || '',
    imgId: localStorage.getItem('imgId') || '',
    otherSettingId: localStorage.getItem('otherSettingId') || '',
    videoId: localStorage.getItem('videoId') || '',
    bannerId: localStorage.getItem('bannerId') || '',
    columnId: localStorage.getItem('columnId') || '',
    activityList: [],
    videoList: [],
    imgsList: [],
    total: 0,
    columns: [],
    imgColumn: [],
    notificationMessage: '',
    videoColumn: [],
    settings: [],
    config: JSON.parse(localStorage.getItem('myConfig')) || {},
    configDetail: [],
    otherSettingData:
      JSON.parse(localStorage.getItem('otherSettingData')) || [],
    otherSettingDetail:
      JSON.parse(localStorage.getItem('otherSettingDetail')) || {},
    linkList: [],
    otherSettings: [],
    overSeaData: [],
    countryData: [],
    bannerList: [],
    parentWebs: [],
    title: '',
    keywords: '',
    describe: '',
    name: '',
    catalog: '',
    favicon: '',
    parentId: '',
    moduleList: [],
    template_id: localStorage.getItem('templateId') || '',
    webSiteName: localStorage.getItem('webSiteName') || '',
    columnName: localStorage.getItem('columnName') || '',
    parent_id: '',
    is_overSea: localStorage.getItem('is_overSea') || '',
    user_name: '',
    linkDetail: JSON.parse(localStorage.getItem('linkDetail')) || {},
  },
  actions: {
    getInfo({ commit }) {
      axios
        .get(`${api.url}list`)
        .then((response) => {
          const data = response.data;
          if (data.ret === 0) {
            commit('getOverSeaData', data.content.overSeaData);
            commit('getCountryData', data.content.countryData);
            commit('user_name', data.content.user.real_name);
            localStorage.setItem('user_name', data.content.user.real_name);
          }
        });
    },
    async getWebsiteDetail({ commit }, { id = '', type = '' }) {
      await axios.get(`${api.url}getOne`, { params: { id } }).then((response) => {
        if (response.data.ret === 0) {
          const detail = response.data.content.detail;
          const isOverSea = detail.is_overSea;
          const wid = detail._id;
          const templateId = detail.template_id;
          const parentId = detail.parent_id;
          const name = detail.name;
          commit('getTitle', detail.title);
          commit('getIs_page', detail.is_page);
          commit('getHave_page', detail.have_page);
          commit('getKeywords', detail.keywords);
          commit('getDescribe', detail.describe);
          commit('getName', detail.name);
          commit('getCatalog', detail.catalog);
          commit('getParentId', detail.parent_id);
          commit('getFavicon', detail.favicon);
          commit('getIs_overSea', detail.is_overSea);
          if (type === 'webSet') {
            this.dispatch('getParentWeb', { id: wid, isOverSea });
          } else {
            this.dispatch('getConfigDetail', {
              template_id: templateId,
              parent_id: parentId,
              name,
            });
          }
        }
      });
    },
    getParentWeb({ commit }, { id = '', isOverSea = false }) {
      axios
        .post(`${api.url}getParentWeb`, { wid: id, is_overSea: isOverSea })
        .then((response) => {
          if (response.data.ret === 0) {
            commit('getParentWeb', response.data.content);
          }
        });
    },
    getConfigDetail({ commit }, data) {
      axios
        .post(`${api.url}moduleDetail`, {
          id: data.template_id,
          parent_id: data.parent_id,
          name: data.name,
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const moduleDetail = response.data.content;
            commit('getConfigLeftNav', { data: moduleDetail });
          }
        })
        .catch(() => {});
    },
    getColumnDetail({ commit }, data) {
      axios
        .get(`${api.url}getColumnDetail`, { params: data })
        .then((response) => {
          if (response.data.ret === 0) {
            const configList = response.data.configList;
            const columnDetail = {};
            columnDetail.configList = configList.configList;
            columnDetail.article = configList.article;
            columnDetail.imgs = configList.imgs;
            columnDetail.videos = configList.videos;
            columnDetail.banner = configList.banner;
            columnDetail.settings = configList.settings;
            columnDetail.otherSettings = configList.otherSettings;
            commit('getConfigLeftNav', { data: columnDetail });
          }
        })
        .catch(() => {});
    },
    getArticle(
      { commit },
      {
        type = '',
        searchTitle = '',
        wid,
        pageNum = 1,
        pageSize = 20,
        release = '',
      },
    ) {
      axios
        .get(`${api.url}articleList`, {
          params: {
            type,
            searchTitle,
            wid,
            pageSize,
            pageNum,
            release,
          },
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const data = response.data;
            const msg = data.msg;
            const total = data.total;
            commit('getArticle', { msg, total });
          }
        });
    },
    getImages({ commit }, { type = '', wid }) {
      axios
        .get(`${api.url}imgsList`, {
          params: {
            type,
            wid,
          },
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const data = response.data;
            const msg = data.msg;
            commit('getImages', { msg });
          }
        });
    },
    getVideoList({ commit }, { type = '', wid }) {
      axios
        .get(`${api.url}videoList`, {
          params: {
            type,
            wid,
          },
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const data = response.data;
            const msg = data.msg;
            commit('getVideoList', { msg });
          }
        });
    },
    getBannerList({ commit }, { type = '', wid }) {
      axios
        .get(`${api.url}bannerList`, {
          params: {
            type,
            wid,
          },
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const data = response.data;
            const msg = data.msg;
            commit('getBannerList', { msg });
          }
        });
    },
    getModuleList({ commit }, isOverSea) {
      axios
        .get(`${api.url}modulelist`, {
          params: { is_overSea: isOverSea },
        })
        .then((response) => {
          if (response.data.ret === 0) {
            const data = response.data;
            const msg = data.content;
            commit('getModuleList', { msg });
          }
        });
    },
  },
  mutations: {
    getConfigLeftNav(state, msg) {
      state.configLeftNav = {
        content: [],
        seo: [],
      };
      const res = msg.data;
      if (res.article) {
        if (res.article.length > 0) {
          state.configLeftNav.content.push({
            name: '文章管理',
            path: 'article',
            children: res.article,
          });
        }
        state.columns = res.article;
      }
      if (res.imgs) {
        if (res.imgs.length > 0) {
          state.configLeftNav.content.push({
            name: '图片管理',
            path: 'img',
            children: res.imgs,
          });
        }
      }
      if (res.videos) {
        if (res.videos.length > 0) {
          if (res.videos.length > 0) {
            state.configLeftNav.content.push({
              name: '视频管理',
              path: 'videos',
              children: res.videos,
            });
          }
        }
      }
      if (res.banner) {
        if (res.banner.length > 0) {
          state.configLeftNav.content.push({
            name: 'BANNER',
            path: 'other_banner',
            children: res.banner,
          });
        }
      }
      if (res.settings) {
        if (res.settings.length > 0) {
          state.configLeftNav.content.push({
            name: '其他设置',
            path: 'other_set',
            children: res.settings,
          });
          this.commit('getSettings', res.settings);
        }
      }
      state.configLeftNav.seo.push({ name: '基本参数设置', path: 'setting' });
      if (res.otherSettings) {
        if (res.otherSettings.length > 0) {
          state.configLeftNav.content.push({
            name: '特殊设置',
            path: 'otherSettings',
            children: res.otherSettings,
          });
          this.commit('getOtherSettings', res.otherSettings);
        }
      }
    },
    getConfigDetail(state, res) {
      state.configDetail = res;
    },
    getOverSeaData(state, res) {
      state.overSeaData = res;
    },
    getCountryData(state, res) {
      state.countryData = res;
    },
    getArticle(state, data) {
      const res = data.msg;
      for (let i = 0; i < res.length; i += 1) {
        res[i].updateTime = moment(new Date(res[i].updateTime)).format(
          'YYYY-MM-DD HH:mm:ss',
        );
        res[i].editTime = moment(new Date(res[i].editTime)).format(
          'YYYY-MM-DD',
        );
        for (let j = 0; i < res[i].length; j += 1) {
          if (res[i][j].indexOf(state.navName) >= 0) {
            res[i].isSetHome = true;
          }
        }
      }
      state.activityList = res;
      state.total = data.total;
    },
    getImages(state, data) {
      const res = data.msg.sort(api.getSortArr('sort'));
      for (let i = 0; i < res.length; i += 1) {
        res[i].updateTime = moment(new Date(res[i].updateTime)).format(
          'YYYY-MM-DD HH:mm:ss',
        );
      }
      state.imgsList = res;
    },
    getVideoList(state, data) {
      const res = data.msg;
      for (let i = 0; i < res.length; i += 1) {
        res[i].updateTime = moment(new Date(res[i].updateTime)).format(
          'YYYY-MM-DD HH:mm:ss',
        );
      }
      state.videoList = res;
    },
    getBannerList(state, data) {
      const res = data.msg;
      for (let i = 0; i < res.length; i += 1) {
        res[i].updateTime = moment(new Date(res[i].updateTime)).format(
          'YYYY-MM-DD HH:mm:ss',
        );
      }
      state.bannerList = res;
    },
    setNavName(state, name) {
      state.navName = name;
    },
    getWebSite(state, id) {
      state.websiteId = id;
    },
    getWebSiteChildIds(state, arr) {
      state.webSiteChildIds = arr;
    },
    getColumnId(state, id) {
      state.columnId = id;
    },
    getArticleId(state, id) {
      state.articleId = id;
    },
    getLinkId(state, id) {
      state.linkId = id;
    },
    getEditorContent(state, text) {
      state.editContent = text;
    },
    getOtherSettingId(state, id) {
      state.otherSettingId = id;
    },
    changeLoading(state, type) {
      state.loading = type;
    },
    getPublicUrl(state, type) {
      if (type) {
        localStorage.setItem('publicUrl', `${api.url}public/upload/overseas/`);
        state.publicUrl = `${api.url}public/upload/overseas/`;
      } else {
        localStorage.setItem('publicUrl', `${api.url}public/upload/home/`);
        state.publicUrl = `${api.url}public/upload/home/`;
      }
    },
    getImgId(state, id) {
      state.imgId = id;
    },
    getVideoId(state, id) {
      state.videoId = id;
    },
    getWebSiteName(state, name) {
      state.webSiteName = name;
    },
    getColumnName(state, name) {
      state.columnName = name;
    },
    getParentWeb(state, data) {
      data.unshift({ _id: '0', name: '首级' });
      state.parentWebs = data;
    },
    getSettings(state, data) {
      // const settings = data;
      // eslint-disable-next-line no-unused-vars
      // const isDouble = false;

      // for (let i = 0; i < router.options.routes[0].children.length; i += 1) {
      //   if (
      //     router.options.routes[0].children[i].path === `/${settings[0].config}`
      //   ) {
      //     isDouble = true;
      //   }
      // }
      state.settings = data;
    },
    getBanner(state, data) {
      localStorage.setItem('bannerList', JSON.stringify(data));
      state.bannerList = data;
    },
    getLink(state, data) {
      state.linkList = data;
    },
    getLinkDetail(state, data) {
      state.linkDetail = data;
    },
    getOtherSettings(state, data) {
      state.otherSettings = data;
    },
    setOtherSettingDetail(state, data) {
      state.otherSettingDetail = data;
    },
    getOtherSettingDetail(state, data) {
      state.otherSettingDetail = data;
      axios
        .get(`${api.url}otherSettingList`, {
          params: {
            config: data.config,
            wid: state.websiteId,
          },
        })
        .then((response) => {
          const arrayData = [];
          const content = response.data.content;
          for (let i = 0; i < content.length; i += 1) {
            const otherSettingList = {};
            for (let j = 0; j < content[i].setConfig.length; j += 1) {
              otherSettingList[content[i].setConfig[j].config.name] =
                content[i].setConfig[j].config.content;
            }
            otherSettingList.updateTime = moment(
              new Date(content[i].updateTime),
            ).format('YYYY-MM-DD HH:mm:ss');
            otherSettingList.editors = content[i].editors;
            otherSettingList._id = content[i]._id;
            otherSettingList.sort = content[i].sort;
            otherSettingList.release = `${content[i].release}`;
            arrayData.push(otherSettingList);
          }
          state.otherSettingData = arrayData;
        });
    },
    getName(state, data) {
      state.name = data;
    },
    getCatalog(state, data) {
      state.catalog = data;
    },
    getNotificationMessage(state, data) {
      const msgArr = `${state.notificationMessage}`.split('&nbsp;&nbsp;&nbsp;&nbsp;');
      const msg = `${msgArr.slice(-4).join('&nbsp;&nbsp;&nbsp;&nbsp;')}<i class="iconfont">&#xe62b;</i>&nbsp;${data.msg} &nbsp;&nbsp;&nbsp;&nbsp;`;
      state.notificationMessage = `${msg}`;
    },
    getParentId(state, data) {
      state.parent_id = data;
    },
    getFavicon(state, data) {
      state.favicon = data;
    },
    getBannerId(state, id) {
      localStorage.setItem('bannerId', id);
      state.bannerId = id;
    },
    getTitle(state, title) {
      localStorage.setItem('title', title);
      state.title = title;
    },
    getIs_page(state, isPage) {
      state.is_page = isPage;
    },
    getHave_page(state, havePage) {
      state.have_page = havePage;
    },
    getIs_overSea(state, isDouble) {
      state.is_overSea = isDouble;
    },
    getKeywords(state, keywords) {
      localStorage.setItem('keywords', keywords);
      state.keywords = keywords;
    },
    getDescribe(state, describe) {
      localStorage.setItem('describe', describe);
      state.describe = describe;
    },
    getconfig(state, configData) {
      const configDetail = [];
      const myobject = {};
      axios
        .get(`${api.url}getSettings`, {
          params: {
            config: configData.config,
            wid: state.websiteId,
          },
        })
        .then((response) => {
          const data = response.data;
          if (data.ret === 0) {
            if (data.content.length > 0) {
              state.config = data.content[0];
              const arr = data.content[0].setConfig;
              for (let i = 0; i < arr.length; i += 1) {
                myobject[arr[i].config.name] = arr[i].config.content;
              }
              configDetail.push(myobject);
            } else {
              state.config = configData;
              const arr = configData.setConfig;
              for (let i = 0; i < arr.length; i += 1) {
                myobject[arr[i].config.name] = arr[i].config.content;
              }
              configDetail.push(myobject);
            }
            state.configDetail = configDetail;
          }
        });
    },
    getModuleList(state, data) {
      state.moduleList = data.msg;
    },
    getTemplate(state, id) {
      state.template_id = id;
    },
    user_name(state, name) {
      state.user_name = name;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js